export default {
  'loading': 'Carregant . . .',
  'nombre': 'Nom',
  'telefono': 'Telèfon',
  'codigo': 'Codi',
  'email': 'Email',
  'activo': 'Actiu',
  'estado': 'Estat',
  'descripcion': 'Descripció',
  'usuario': 'Usuari',
  'clave': 'Clau',
  'si': 'Sí',
  'no': 'No',
  'cargando': 'Carregant...',
  'maestros': {
    'editar': 'Editar',
    'eliminar': 'Eliminar',
  },
  'mensajes': {
    'confirmar': 'Confirmació',
    'pregunta-borrar': '¿Està segur que vol eliminar "',
  },
};
